import { LinearProgress } from '@mui/material';

export default function LoadingComponent(props) {
  return (
    <div>
      <LinearProgress
        sx={{
          '& .MuiLinearProgress-bar': {
            backgroundColor: '#00E2BE',
          },
        }}
      />
    </div>
  );
};
